import { useIsMobile } from '@/hooks/use-mobile'
import { FileTextIcon, HomeIcon, ScanIcon } from 'lucide-react'
import { Link, useLocation } from '@tanstack/react-router'
import { cn } from '@/lib/utils'

export function BottomNavDashboard() {
  const isMobile = useIsMobile()
  const { pathname } = useLocation()

  const isScan = pathname.includes('/scan')
  const isHome = pathname.includes('/home')
  const isDocuments = pathname.includes('/documents')

  if (!isMobile) return null

  return (
    <nav className="border-border fixed inset-0 top-auto bottom-0 z-40 grid h-20 w-full grid-cols-3 items-center justify-between border-t bg-[#fbfaff] p-2">
      <Link
        to="/scan"
        className={cn(
          'text-copy-secondary flex h-full items-center justify-center rounded-xl',
          isScan && 'text-primary bg-primary-light/50',
        )}
      >
        <ScanIcon className="size-6" />
      </Link>
      <Link
        to="/home"
        className={cn(
          'text-copy-secondary flex h-full items-center justify-center rounded-xl',
          isHome && 'text-primary bg-primary-light/50',
        )}
      >
        <HomeIcon className="size-6" />
      </Link>
      <Link
        to="/documents"
        className={cn(
          'text-copy-secondary flex h-full items-center justify-center rounded-xl',
          isDocuments && 'text-primary bg-primary-light/50',
        )}
      >
        <FileTextIcon className="size-6" />
      </Link>
    </nav>
  )
}
